// Textos e regras compartilhados entre o cabecalho (TicketInfo) e a barra
// lateral (ContactDrawer) sobre as informacoes do cliente.

export const APARELHOS = {
  iphone: { rotulo: "iPhone", dica: "Celular do cliente: iPhone" },
  android: { rotulo: "Android", dica: "Celular do cliente: Android" },
};

export const ORIGENS = {
  sms_clt: "SMS CLT",
  sms_fgts: "SMS FGTS",
};

export const PRODUTOS = {
  consignado_clt: "CLT",
  fgts: "FGTS",
  ambos: "CLT+FGTS",
};

export const rotuloOrigem = (info) =>
  ORIGENS[info?.origem] ||
  (PRODUTOS[info?.produto] ? `Direto · ${PRODUTOS[info.produto]}` : "Direto");

export const tempoDesde = (iso, agora) => {
  if (!iso) return "";
  const min = Math.max(0, Math.floor((agora - new Date(iso).getTime()) / 60000));
  if (min < 1) return "agora";
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h${min % 60 ? ` ${min % 60}min` : ""}`;
  const d = Math.floor(h / 24);
  return d === 1 ? "1 dia" : `${d} dias`;
};

export const quandoConsultou = (iso, agora) => {
  if (!iso) return "";
  const dias = Math.floor((agora - new Date(iso).getTime()) / 86400000);
  if (dias <= 0) return "consultou hoje";
  if (dias === 1) return "consultou ontem";
  return `consultou há ${dias} dias`;
};

const hora = (d) =>
  d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

export const vistoPorUltimo = (ms, agora) => {
  if (!ms) return "";
  const d = new Date(ms);
  const hoje = new Date(agora);
  const ontem = new Date(agora - 86400000);
  if (d.toDateString() === hoje.toDateString()) return `visto por último hoje às ${hora(d)}`;
  if (d.toDateString() === ontem.toDateString()) return `visto por último ontem às ${hora(d)}`;
  return `visto por último em ${d.toLocaleDateString("pt-BR")} às ${hora(d)}`;
};

// { tipo: "online" | "offline" | "digitando", texto } ou null (sem informacao)
export const textoPresenca = (presenca, agora) => {
  if (!presenca?.status) return null;
  if (presenca.status === "composing") return { tipo: "digitando", texto: "digitando..." };
  if (presenca.status === "recording") return { tipo: "digitando", texto: "gravando áudio..." };
  if (presenca.status === "available") return { tipo: "online", texto: "online" };
  if (presenca.lastSeen) return { tipo: "offline", texto: vistoPorUltimo(presenca.lastSeen, agora) };
  return { tipo: "offline", texto: "offline" };
};

// ---- Leilao (Sistema de Disparo) ------------------------------------------

export const numeroLeilao = (v) => {
  if (v === null || v === undefined || v === "") return null;
  if (typeof v === "number") return Number.isFinite(v) && v > 0 ? v : null;
  const t = String(v).trim();
  const n = /,\d{1,2}$/.test(t)
    ? parseFloat(t.replace(/\./g, "").replace(",", "."))
    : parseFloat(t.replace(/[^\d.]/g, ""));
  return Number.isFinite(n) && n > 0 ? n : null;
};

export const moedaBR = (v) => {
  const n = numeroLeilao(v);
  return n === null ? "" : n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

// "Pediu R$ 10.000 · 24x" (selo do cabecalho)
export const resumoPedidoLeilao = (leilao) => {
  const valor = numeroLeilao(leilao?.dados?.valor);
  if (!valor) return "";
  const parcelas = numeroLeilao(leilao?.dados?.parcelas);
  const v = valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
  return `Pediu ${v}${parcelas ? ` · ${parcelas}x` : ""}`;
};

const paraData = (v) => {
  const t = String(v || "").trim();
  if (!t) return null;
  let m = t.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
  if (m) return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
  m = t.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:[ T](\d{2}):(\d{2}))?/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0));
  return null;
};

const dataBR = (v, comHora = false) => {
  const d = paraData(v);
  if (!d) return String(v || "");
  const dia = d.toLocaleDateString("pt-BR");
  return comHora ? `${dia} ${d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}` : dia;
};

const tempoDeCasa = (v, agora) => {
  const d = paraData(v);
  if (!d) return "";
  let meses = (new Date(agora).getFullYear() - d.getFullYear()) * 12 + (new Date(agora).getMonth() - d.getMonth());
  if (new Date(agora).getDate() < d.getDate()) meses -= 1;
  if (meses < 0) return "";
  const anos = Math.floor(meses / 12);
  const resto = meses % 12;
  const partes = [];
  if (anos) partes.push(`${anos} ano${anos > 1 ? "s" : ""}`);
  if (resto || !anos) partes.push(`${resto} ${resto === 1 ? "mês" : "meses"}`);
  return partes.join(" e ");
};

const validadeComStatus = (v, agora) => {
  const d = paraData(v);
  if (!d) return String(v || "");
  const horas = (d.getTime() - agora) / 3600000;
  const quando = dataBR(v, true);
  if (horas < 0) return `${quando} · expirada`;
  if (horas < 24) return `${quando} · vence em ${Math.max(1, Math.round(horas))}h`;
  return `${quando} · disponível`;
};

const cnpjMascara = (v) => {
  const d = String(v || "").replace(/\D/g, "");
  if (d.length !== 14) return String(v || "");
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
};

const humanizar = (k) =>
  String(k)
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/^./, (c) => c.toUpperCase());

const ORIGEM_LEILAO = { handmais: "Handmais", odysseia: "Odysseia", unix: "Unix", clt: "CLT", clt2: "CLT 2", suabank: "Sua Bank" };

// Lista de campos { id, name, value } no mesmo formato da ficha do contato.
export const camposDoLeilao = (leilao, agora = Date.now()) => {
  if (!leilao) return [];
  const d = leilao.dados || {};
  const lista = [];
  const add = (name, value) => {
    if (value === null || value === undefined || String(value).trim() === "") return;
    lista.push({ id: `leilao-${lista.length}`, name, value: String(value) });
  };
  add("Valor solicitado", moedaBR(d.valor));
  add("Parcelas", numeroLeilao(d.parcelas) ? `${numeroLeilao(d.parcelas)}x` : d.parcelas);
  add("Margem", moedaBR(d.margem));
  add("Disponível até", d.validade ? validadeComStatus(d.validade, agora) : "");
  add("Admissão", d.admissao ? `${dataBR(d.admissao)}${tempoDeCasa(d.admissao, agora) ? ` · ${tempoDeCasa(d.admissao, agora)} de casa` : ""}` : "");
  add("Nascimento", d.nascimento ? dataBR(d.nascimento) : "");
  add("Elegível", d.elegivel);
  add("Matrícula", d.matricula);
  add("Empregador", d.empregador);
  add("CNPJ do empregador", d.cnpj_empregador ? cnpjMascara(d.cnpj_empregador) : "");
  add("Tipo de contrato", d.tipo_contrato);
  add("Saldo FGTS", moedaBR(d.valor_fgts));
  add("Cidade", [d.cidade, d.uf].filter(Boolean).join(" / "));
  add("Nº da solicitação", d.solicitacao);
  add("Origem no Leilão", ORIGEM_LEILAO[String(leilao.origem || "").toLowerCase()] || leilao.origem);
  add("Chegou no Leilão", leilao.recebido_em ? dataBR(leilao.recebido_em, true) : "");
  add("SMS enviado", leilao.sms?.enviado_em ? dataBR(leilao.sms.enviado_em, true) : leilao.sms?.criado_em ? `${dataBR(leilao.sms.criado_em, true)} (na fila)` : "");
  Object.entries(d.extras || {}).forEach(([k, v]) => add(humanizar(k), typeof v === "boolean" ? (v ? "Sim" : "Não") : v));
  return lista;
};
